import axios from "axios";
import { FetchColumnsParams, FetchDataMainParams, FetchDataSummaryParams, FetchReportFactoryParams } from "../types/request";

// export const BACKEND_URL = 'http://localhost:1439'
// export const STRAPI_TOKEN = '';

// export const BACKEND_URL = 'https://supplyportal.srv.deareditor.ru'


export const STRAPI_TOKEN=''
export const BACKEND_URL = 'https://supply.napitkivmeste.ru'

export const getAuthConfig = () => {
  return {
    headers: {
      Authorization: `Bearer ${STRAPI_TOKEN}`,
    },
    withCredentials: true,
  };
};

export const fetchFiltersVPO = async () => {
  const response = await fetch(`${BACKEND_URL}/api/vpo-groups?populate=columns&populate=factories`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data.data;
}

export const fetchColumnsVPO = async (params: FetchColumnsParams) => {
  const response = await fetch(`${BACKEND_URL}/api/vpo-columns?sort=SortNumber:asc&filters[group][id][$in]=${params.group}&populate=*`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data.data;
}

export const fetchCurrentDateVPO = async () => {
  const response = await fetch(`${BACKEND_URL}/api/vpo-available-questionnaires?populate[isAudit][populate]=*`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data.data;
}

export const fetchDataMainVPO = async (params: FetchDataMainParams) => {
  const stringParams = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, String(value)])
  );

  const query = new URLSearchParams(stringParams).toString();

  const response = await fetch(`${BACKEND_URL}/api/vpo-data-main?${query}`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data;
};

export const fetchDataSummaryVPO = async (params: FetchDataSummaryParams) => {
  const stringParams = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, String(value)])
  );

  const query = new URLSearchParams(stringParams).toString();

  const response = await fetch(`${BACKEND_URL}/api/vpo-data-summary?${query}`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return data;
};

export const fetchReportFactory = async (params: FetchReportFactoryParams, signal?: AbortSignal) => {
  try {
    const query = new URLSearchParams();

    params.group.forEach((group) => query.append("group", String(group)));
    params.year.forEach((year) => query.append("year", String(year)));
    params.month.forEach((month) => query.append("month", String(month)));
    params.column.forEach((column) => query.append("column", String(column)));
    params.factory.forEach((factory) => query.append("factory", String(factory)));

    const response = await fetch(
      `${BACKEND_URL}/api/vpo-report-factory?${query.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${STRAPI_TOKEN}`,
          "Content-Type": "application/json",
        },
        credentials: 'include',
        signal,
      }
    );

    if (!response.ok) {
      console.error("Ошибка ответа сервера:", response.statusText);
      return [];
    }

    const data = await response.json();
    return data;
  } catch (error) {
    if ((error as any)?.name === 'AbortError') {
      return [];
    }
    console.error("Ошибка при выполнении запроса:", error);
    return [];
  }
};




export const getData = (modelName: string, params = {}) => {
  return axios.get(`${BACKEND_URL}/api/${modelName}?populate=*`, {
    ...getAuthConfig(),
    params,
  });
};

export const extractStrapiData = (response: any) => {
  if (response && response.data && response.data.data) {
    return response.data.data;
  }
  if (response && response.data) {
    return response.data;
  }
  return [];
};

export const addData = (modelName: string, data: any) => {
  const formattedData = data.data ? data : { data };
  return axios.post(`${BACKEND_URL}/api/${modelName}`, formattedData, getAuthConfig()).catch((error) => {
    console.error('Ошибка API:', error.response?.data || error.message);
    throw error;
  });
};

export const updateData = (modelName: string, documentId: string, data: any) => {
  const formattedData = data.data ? data : { data };
  return axios.put(`${BACKEND_URL}/api/${modelName}/${documentId}`, formattedData, getAuthConfig()).catch((error) => {
    console.error('Ошибка API:', error.response?.data || error.message);
    throw error;
  });
};

export const deleteData = (modelName: string, documentId: string) => {
  return axios.delete(`${BACKEND_URL}/api/${modelName}/${documentId}`, getAuthConfig()).catch((error) => {
    console.error('Ошибка API:', error.response?.data || error.message);
    throw error;
  });
};

export const getVPOCombinedActions = async (params: any = {}) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/vpo-combined-actions/joined`, {
      ...getAuthConfig(),
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении VPO Combined Actions:', error);
    throw error;
  }
};

export const getReportsData = async (params: { factories: number[]; columns: number[]; month?: number; year?: string; subdivisions?: number[]; group?: number }) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/vpo-get-data-reports`, {
      ...getAuthConfig(),
      params,
    });
    return response;
  } catch (error) {
    console.error('Ошибка при получении отчетов:', error);
    throw error;
  }
};

export const fetchInconsistenciesByActionId = async (actionId: number): Promise<any> => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/vpo-inconsistencies`, {
      ...getAuthConfig(),
      params: {
        'filters[IdVPOactions][$eq]': actionId,
        populate: '*',
      },
    });

    if (response.data?.data) {
      return response.data.data;
    } else {
      return [];
    }
  } catch (error: any) {
    console.error(`Ошибка при загрузке несоответствий для действия ${actionId}:`, error);
    if (error.response?.data?.error) {
      console.error('Детали ошибки:', error.response.data);
      throw new Error(error.response.data.error);
    }
    throw new Error(`Ошибка при загрузке несоответствий`);
  }
};

export const fetchDataByContext = async (modelName: string, context: any): Promise<any> => {
  try {
    const filters: Record<string, any> = {};
console.log('context',context)
    if (context.currentMonth) {
      filters['month'] = context.currentMonth;
    }
    if (context.currentYear) {
      filters['year'] = context.currentYear;
    }
    if (context.factory?.id) {
      filters['factory'] = context.factory.id;
    }
    if (context.group?.id) {
      filters['group'] = context.group.id;
    }
    if (context.column?.id) {
      filters['column'] = context.column.id;
    }
    if (context.columnBlock?.id) {
      filters['columnBlock'] = context.columnBlock.id;
    }
    if (context.demand?.id) {
      filters['requirement'] = context.demand.id;
    }
    if (context.subdivision?.id) {
      filters['department'] = context.subdivision.id;
    }
    if (context.process?.id) {
      filters['process'] = context.process.id;
    }

    const params: Record<string, any> = { populate: '*' };
    Object.entries(filters).forEach(([key, value]) => {
      params[`filters[${key}]`] = value;
    });

    const response = await axios.get(`${BACKEND_URL}/api/${modelName}`, {
      ...getAuthConfig(),
      params,
    });

    if (response.data?.data) {
      return response.data.data;
    } else {
      return [];
    }
  } catch (error: any) {
    console.error(`Ошибка при поиске данных из ${modelName}:`, error);
    if (error.response?.data?.error) {
      console.error('error:', error.response.data);
      throw new Error(error.response.data.error);
    }
    throw new Error(`Ошибка при поиске данных в ${modelName}`);
  }
};

export const getActionsOnlyVPO = async (params: { factory: number; month: number; year: string; column: number; group: number }) => {
  const stringParams = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, String(value)])
  );

  const query = new URLSearchParams(stringParams).toString();

  const response = await fetch(`${BACKEND_URL}/api/vpo-actions-only?${query}`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};

export const getReportCompletedActionsData = async (params: {
  columnId: string[];
  groupIds: number[];
  factoryIds: number[];
  year: string;
  departmentIds: number[];
}) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/vpo-report-completed-actions`, {
      ...getAuthConfig(),
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении отчета по выполненным действиям:', error);
    throw error;
  }
};

export const fetchSettings = async () => {
  const response = await fetch(`${BACKEND_URL}/api/vpo-settings?populate=*`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return Array.isArray(data.data) ? data.data : [data.data];
};

//! для получения карточки VPO с ID relations (group и factory)
export const fetchActionByIdVPO = async (actionId: number): Promise<any> => {
  try {
    const response = await axios.get(
      `${BACKEND_URL}/api/vpo-actions?filters[id][$eq]=${actionId}&populate[factory][fields]=id&populate[group][fields]=id&populate[column][fields]=id&fields[0]=month&fields[1]=year`,
      getAuthConfig()
    );

    if (response.data?.data && response.data.data.length > 0) {
      return response.data.data[0];
    }
    throw new Error('Карточка VPO не найдена');
  } catch (error: any) {
    console.error(`Ошибка получения карточки VPO ID ${actionId}:`, error);
    throw error;
  }
};

//! Получение правильного месяца/года опросника для карточки VPO
// export const fetchActionQuestionnaireMonth = async (actionId: number): Promise<{ month: number; year: number }> => {
//   const response = await axios.get(
//     `${BACKEND_URL}/api/vpo-action-questionnaire?actionId=${actionId}`,
//     getAuthConfig()
//   );
//   return response.data;
// };
